import TextMediaBigStyles from "../../../modules/TextMediaBig/TextMediaBig.module.scss";
import TextMediaSliderStyles from "../../../modules/FullWidthSlider/FullWidthSlider.module.scss";
import InfoboxStyles from "../../../modules/InfoBoxModule/InfoBoxesModule.module.scss";
import CTAStyles from "../../../modules/CTA/CTA.module.scss";
import CTAListStyles from "../../../modules/CTAList/CTAListBox/CTAListBox.module.scss";
import { BreakpointValues, breakpointValuesToClassNames } from "./breakpoints";

interface getItemAttributesParams {
  itemWidth?: string | BreakpointValues;
  itemHeight?: string | BreakpointValues;
  className?: string;
  itemAttrFor: "textmedia" | "textmedia-slider" | "infobox" | "cta" | "ctalist";
}

export const getItemAttributes = ({
  itemWidth = "auto",
  itemHeight = "auto",
  className = "",
  itemAttrFor,
}: getItemAttributesParams) => {
  const styles =
    itemAttrFor === "textmedia-slider"
      ? TextMediaSliderStyles
      : itemAttrFor === "textmedia"
        ? TextMediaBigStyles
        : itemAttrFor === "cta"
          ? CTAStyles
          : itemAttrFor === "ctalist"
            ? CTAListStyles
            : InfoboxStyles;

  const mapBreakpointValuesToCSSVars = (
    values: string | BreakpointValues,
    prefix: "item-width" | "item-height",
  ) => {
    if (typeof values === "string") {
      return { [`--${prefix}`]: values };
    }
    return {
      [`--${prefix}`]: values.mobile ?? "100%",
      [`--${prefix}-tablet`]: values.tablet,
      [`--${prefix}-desktop`]: values.desktop,
      [`--${prefix}-widescreen`]: values.widescreen,
      [`--${prefix}-fullhd`]: values.fullhd,
      [`--${prefix}-ultrahd`]: values.ultrahd,
    };
  };

  const widthCSSVars = mapBreakpointValuesToCSSVars(itemWidth, "item-width");
  const heightCSSVars = mapBreakpointValuesToCSSVars(itemHeight, "item-height");

  return {
    className: `${styles.item || ""}  ${className || ""} ${
      typeof itemWidth !== "string"
        ? breakpointValuesToClassNames(itemWidth, "width", styles)
        : ""
    } ${
      typeof itemHeight !== "string"
        ? breakpointValuesToClassNames(itemHeight, "height", styles)
        : ""
    }`,
    style: {
      ...widthCSSVars,
      ...heightCSSVars,
    },
  };
};
